import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a9808e5f142bdcfafc950533465cdf5ccb from "./generated-19eb31d3-ee2f-4d78-b3e5-f2da8fc83491.json";

import ab5cd385e44e16d117712636b8d9e9d3fb from "./generated-eb5aac65-bec4-4f55-ab45-1703baec7da7.json";

import aea724565a24b72792a5f7e9d39387228b from "./generated-de26c08a-03fd-4ccc-879c-1ba095ca0d74.json";

import a0172d73ddd9d394b8db42d26a3e55000b from "./generated-700fef73-1883-4f5b-b257-28896643cafe.json";

import abc68cc432fd2ebc6bce01dc827883b2eb from "./generated-80939629-a997-4d00-a45d-4cc029f898ae.json";

import aa608e35003106effd107f2eb578d3626b from "./generated-aec678cc-c743-4e93-9729-529f4922bd65.json";

import abbe2e5a9302d59bf862bb146d6fbc4deb from "./generated-d73c4e63-26a3-43b3-8a7c-e24e0b9aa1e0.json";

import aac4cfed082d041a8acc84bba19255553b from "./generated-35121ef6-70f3-4163-9d76-dd9672dafb74.json";

import a336a30b9c382b8e1fed00bfca22764b5b from "./generated-66ea6bdf-d87c-40b8-9e7e-cca57f00d560.json";

import adc8c68d8d4e27a7a358bb1b89b255ae1b from "./generated-05b0e4d2-9b64-4774-8403-d3c8161e3860.json";

import a780a2c6eb190920376af8b4cffc9d6c8b from "./generated-49ce1a4d-e9c7-4144-8543-f3c015085c82.json";

import ac77e9f15fe440a4525ebe737b38c51a3b from "./generated-472cdd62-67f6-4638-8f40-6ab0c0353305.json";

import a6b5465741d20780d82c103b3c4c93837b from "./generated-54dd4b7f-f769-430f-9966-c1a182921dec.json";

import a00c7f6c8dce3f610794f69cb36c532fab from "./generated-e6c6395b-8614-43d7-acb5-63312812cfed.json";

import a87890492ecf0cb9fd9b5f45e23e51bdcb from "./generated-a098ef91-1361-4b84-82af-28a5a7460470.json";

import a083f9f4616def9caa4c7504d76ffec28b from "./generated-52bc6375-5e7c-4d9a-a518-d91ee9fc1161.json";

import a0712b6571768cbbc6465e11325ea0830b from "./generated-5d1f0b11-64a4-4731-84e0-4e79aa5d1d61.json";

import aff873aae6f38f42303e4637f8197d941b from "./generated-068c8650-8ad3-40b6-8ca5-06470b510f13.json";

import a101056acb37a11474823ee9ae3aa43f2b from "./generated-cab91e00-4f57-4a2b-af0c-2b29683d7649.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a9808e5f142bdcfafc950533465cdf5ccb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(ab5cd385e44e16d117712636b8d9e9d3fb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(aea724565a24b72792a5f7e9d39387228b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a0172d73ddd9d394b8db42d26a3e55000b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(abc68cc432fd2ebc6bce01dc827883b2eb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(aa608e35003106effd107f2eb578d3626b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(abbe2e5a9302d59bf862bb146d6fbc4deb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(aac4cfed082d041a8acc84bba19255553b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a336a30b9c382b8e1fed00bfca22764b5b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(adc8c68d8d4e27a7a358bb1b89b255ae1b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a780a2c6eb190920376af8b4cffc9d6c8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(ac77e9f15fe440a4525ebe737b38c51a3b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a6b5465741d20780d82c103b3c4c93837b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a00c7f6c8dce3f610794f69cb36c532fab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a87890492ecf0cb9fd9b5f45e23e51bdcb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a083f9f4616def9caa4c7504d76ffec28b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a0712b6571768cbbc6465e11325ea0830b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(aff873aae6f38f42303e4637f8197d941b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a101056acb37a11474823ee9ae3aa43f2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a0712b6571768cbbc6465e11325ea0830b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */